import Typography from "@common/components/Typography";
import Grid from '@mui/material/Grid2';
import { displayDate } from "@common/utils/localTime.utils";
import { Box } from "@mui/material";
import { ArchivedDevice } from "@services/devices/types";
import React from "react";
import { useTranslation } from "react-i18next";
import { deviceInformations } from "../../const";

type DeviceInformationsProps = {
  device?: ArchivedDevice;
};

const DeviceInformations = (props: DeviceInformationsProps) => {
  const { device } = props;
  const { t } = useTranslation();

  return (
    <>
      {deviceInformations(device).map(({ title, data }) => (
        <Box sx={{ mb: 3 }}>
          <Typography uppercase gutterBottom sx={{ fontWeight: "bold" }}>
            {t(`${title}`)}
          </Typography>
          {data?.map(({ label, value }) => (
            <Grid
              container
              sx={{ width: '100%', justifyContent: "space-between",
                alignItems: "center" }}>
              {title === "Device Notes" ? (
                <Box
                  sx={{
                    backgroundColor: ({ palette }) => palette.background.paper,
                    borderRadius: ({ radius }) => radius.small,
                    width: "100%",
                    minHeight: "10rem",
                    p: 2,
                  }}
                >
                  <Typography
                    sx={{ color: ({ palette }) => palette.grey[400] }}
                  >
                    {value}
                  </Typography>
                </Box>
              ) : (
                <>
                  <Typography
                    component="span"
                    sx={{
                      whiteSpace: "nowrap",
                      color: ({ palette }) => palette.grey[400],
                    }}
                  >
                    {t(label ?? "")}
                  </Typography>
                  <Typography
                    reserveSpace
                    component="span"
                    size="small"
                    realTime
                    sx={{
                      color: ({ palette }) => palette.success.main,
                      justifyContent: "end",
                      flex: 1,
                      textAlign: "end",
                      wordBreak: "break-word",
                      maxWidth: "20rem",
                      alignItems: "center",
                    }}
                  >
                    {typeof value === "number" ? displayDate(value) : value}
                  </Typography>
                </>
              )}
            </Grid>
          ))}
        </Box>
      ))}
    </>
  );
};

export default DeviceInformations;
